export default __webpack_public_path__ + "static/media/partner-9.95299526.jpg";